<template>
  <v-row justify="end">
    <SnackBar ref="snackbar" />
    <v-dialog v-model="dialog" width="680">
      <template #activator="{ props }">
        <v-btn
          dark
          class="button-config"
          v-bind="props"
          style="background-color: #004984; text-transform: capitalize"
        >
          Cadastrar Equipe
          <v-icon right style="margin-left: 5px">mdi-plus</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="text-h5">Cadastrar Equipe</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="12">
                <v-text-field
                  v-model="nome_equipe"
                  variant="underlined"
                  label="Nome da Equipe*"
                  :rules="[validateNome]"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="8">
                <v-text-field
                  v-model="org"
                  variant="underlined"
                  label="Nome da Organização*"
                  required
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  v-model.number="numero_membros"
                  variant="underlined"
                  label="N° de Membros*"
                  required
                  @input="validarNumero"
                ></v-text-field>
              </v-col>
              <v-col v-if="numero_membros > 0" cols="12" sm="8" md="12">
                <h5>Membros</h5>
              </v-col>
              <v-col
                v-for="n in numero_membros"
                :key="n"
                cols="12"
                sm="8"
                md="12"
              >
                <h6>{{ n }}° membro</h6>
                <v-select
                  v-model="nomesCadastro[n - 1]"
                  variant="underlined"
                  label="Nome*"
                  :items="nomes"
                ></v-select>
                <v-select
                  v-model="forma_atuacao[n - 1]"
                  variant="underlined"
                  label="Forma de atuação*"
                  :items="tipos"
                ></v-select>
              </v-col>
            </v-row>
          </v-container>
          <small>*Campos Obrigatórios</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue-darken-1" variant="text" @click="fechar">
            Cancelar
          </v-btn>
          <v-btn color="blue-darken-1" variant="text" @click="registerTeam">
            Cadastrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import axios from 'axios';

import SnackBar from '@/components/SnackBar.vue';
import store from '@/store/store';

const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:3000';

export default {
  created() {
    axios
      .get(API_URL + `/projetos/org`, {
        headers: {
          Authorization: `Bearer ${store.state.token}`,
        },
      })
      .then((response) => {
        this.org = response.data;
      })
      .catch((error) => {
        console.error(error);
      });

    axios
      .get(API_URL + `/usuarios/habilitados`, {
        headers: {
          Authorization: `Bearer ${store.state.token}`,
        },
      })
      .then((response) => {
        response.data.forEach((pessoa) => {
          this.pessoas.push(pessoa);
          this.nomes.push(pessoa.nome);
        });
      })
      .catch((error) => {
        console.error(error);
      });
  },
  data: () => ({
    dialog: false,
    numero_membros: null, // eslint-disable-line
    nome_equipe: null, // eslint-disable-line
    org: '',
    emails: [], // eslint-disable-line
    forma_atuacao: [], // eslint-disable-line
    pessoas: [],
    nomes: [],
    nomesCadastro: [],
    tipos: ['DESENVOLVEDOR', 'SCRUM MASTER', 'PRODUCT OWNER', 'TESTADOR - QA'],
  }),
  components: {
    SnackBar,
  },
  methods: {
    validarNumero() {
      // Verifique se o valor é um número, caso contrário, defina-o como nulo
      if (isNaN(this.numero_membros)) {
        // eslint-disable-next-line camelcase
        this.numero_membros = null;
      }
    },
    fechar() {
      this.dialog = false;
      this.nome_equipe = null; // eslint-disable-line
      this.numero_membros = null; // eslint-disable-line
      this.nomesCadastro = [];
      this.forma_atuacao = []; // eslint-disable-line
    },
    validateNome(value) {
      // Use uma expressão regular para permitir letras, espaços em branco e caracteres especiais, mas não apenas números
      const regex =
        /^(?=.*[A-Za-z\s])[\w\s!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~çÇáéíóúÁÉÍÓÚâêîôÂÊÎÔãõÃÕ]+$/u;
      if (!regex.test(value)) {
        return 'O texto inserido contém caracteres inválidos.';
      }

      return true;
    },
    registerTeam() {
      let nomesCadastro = this.nomesCadastro;
      let forma_atuacao = this.forma_atuacao; // eslint-disable-line
      let nomes = this.nomes;
      let pessoas = this.pessoas;
      let membros = [];
      membros = nomesCadastro.map(function (nome, index) {
        // eslint-disable-next-line camelcase
        if (forma_atuacao[index] == 'SCRUM MASTER') {
          forma_atuacao[index] = 'SCRUM_MASTER'; // eslint-disable-line
          // eslint-disable-next-line camelcase
        } else if (forma_atuacao[index] == 'PRODUCT OWNER') {
          // eslint-disable-line
          forma_atuacao[index] = 'PRODUCT_OWNER'; // eslint-disable-line
        }
        var indice = nomes.indexOf(nome);

        return {
          email: pessoas[indice].email,
          forma_atuacao: forma_atuacao[index], // eslint-disable-line
        };
      });
      // TODO: Mock, mudar definição para dinâmico
      const data = {
        nome_equipe: this.nome_equipe, // eslint-disable-line
        org: this.org,
        membros: membros,
      };
      const config = {
        headers: {
          Authorization: `Bearer ${store.state.token}`,
        },
      };
      axios
        .post(API_URL + '/equipes', data, config)
        // eslint-disable-next-line no-unused-vars
        .then((response) => {
          this.$refs.snackbar.showSuccessSnackbar(
            'Concluído!',
            'Equipe [ ' + this.nome_equipe + ' ] cadastrada com sucesso!',
          );
          this.dialog = false;
            this.nome_equipe = null; // eslint-disable-line
          membros = [];
          location.reload();
        })
        .catch((error) => {
          console.log(data);
          /*eslint-disable*/
            this.$refs.snackbar.showErrorSnackbar(
              'Hm... Algo deu errado',
              'Por algum motivo, não conseguimos registrar sua equipe! Verifique os dados fornecidos e tente novamente.'
            );
            /* eslint-enable */
          console.error(error.response.data.error);
        });
    },
  },
};
</script>
